module.exports = __webpack_public_path__ + "aa4405ed937295296cf8510f437628e0.woff2";